/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Move_SubtitleInputs */



/**
* | output |
* | --- |
* | "Select one or more valves to move on the plan or to another room" |
*
* @param {Valve_Move_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_move_subtitle = /** @type {((inputs?: Valve_Move_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Move_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select one or more valves to move on the plan or to another room")
	return /** @type {LocalizedString} */ ("Sélectionnez une ou plusieurs têtes à déplacer sur le plan ou vers une autre pièce")
});